import { createGlobalStyle } from 'styled-components'
import reset from 'styled-reset'
import { media } from '../styles/Mixin'

export default createGlobalStyle`

    ${reset}

    html{
    }

    body{
        /* @font-face { font-family: 'RIDIBatang'; src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_twelve@1.0/RIDIBatang.woff') format('woff'); font-weight: normal; font-style: normal; }
       font-family: 'RIDIBatang'; */
         ${media.deskTop`
            line-height:1.5;
            `}
            ${media.mobile`
            line-height:1.1;
            `}
            
        background-color:${props => props.theme.bgColor};
        
        /* line-height:1.3em; */
    }
`;



